import React from 'react'
import './About.css'
import Footer from '../../general/footer/Footer'
import tsimg1 from "../../assets/Priyanshu jain.jpeg"
// import gallery4 from "../../assets/gallery4.jpg"
// import aboutimg1 from "../../assets/aboutimg1.png"
// import { Link } from 'react-router-dom'
// import { useEffect, useState } from 'react'
import About1 from '../../general/about1/About1'
import TeamSection from '../../general/team-members/TeamSection'


// const testimonials = [
//     {
//         quote: "Great advisory service. Glad to be associated with them.",
//         name: "Kunal Bhartiya",
//         role: "Prebon Yamane India Ltd. (Mumbai)",
//     },
//     {
//         quote: "What they say will do.. guys leave all on them to do. keepitup PSJ Capital Ventures team",
//         name: "Sagar Patel",
//         role: "Businessman (Gujarat)",
//     },
//     {
//         quote: "Happy to say that I will be permanently associated with PSJ Capital Ventures.",
//         name: "Abhilash Reddy Sannapareddy",
//         role: "Injazat Data Systems (Dubai)",
//     },
// ];


const About = () => {

    // const [currentIndex, setCurrentIndex] = useState(0);

    // Auto-slide every 4 seconds
    // useEffect(() => {
    //     const interval = setInterval(() => {
    //         setCurrentIndex((prevIndex) =>
    //             prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
    //         );
    //     }, 4000);
    //     return () => clearInterval(interval);
    // }, []);


    return (
        <div>
            <section className="blog-section">
                <div className="blog-heading">
                    <span className="blog-label">About Us</span>
                    <h2 className="blog-title">
                        Discover PSJ Capital<span className="highlight"></span>
                    </h2>
                    <p className="blog-description">
                        At PSJ Capital , we redefine your Wealth Creation journey. Discover the PSJ Capital  Difference –
                        a commitment to excellence, integrity, and personalized strategies for your ultimate
                        financial growth.
                    </p>
                </div>
            </section>
            <br></br><br></br><br></br><br></br>

            <About1 />


            {/* testimonial */}
            {/* <div className="testimonial-container">
                <h2 className="testimonial-title">What our Clients say about our team</h2>
                <div className="testimonial-wrapper"> */}
            {/* <button className="nav-button left" onClick={goToPrev}>‹</button> */}

            {/* <div className="testimonial-slide">
                        <p className="quote">“{testimonials[currentIndex].quote}”</p>
                        <h4 className="name">{testimonials[currentIndex].name}</h4>
                        <p className="role">{testimonials[currentIndex].role}</p>
                    </div> */}

            {/* <button className="nav-button right" onClick={goToNext}>›</button> */}
            {/* </div> */}
            {/* </div> */}


            <section className="owner-section">
                <div className="owner-container">
                    
                    <div className="owner-content">
                        <h1 className="owner-title">Meet Our Founder</h1>
                        <h6 style={{color:'black'}}>IIM Lucknow | CBS (BFIA) | CFA Level II | FRM Level I | CMT Level I</h6>
                        <p className="owner-description">
                            <strong>Priyanshu Jain </strong>, Founder, PSJ Capital  , an AMFI and APMI registered distributor of Mutual Funds (MF), Portfolio Management Services (PMS), and Alternative Investment Funds (AIF). His vision is to bridge high-quality investment opportunities with discerning clients including HNIs, Ultra HNIs, NRIs, Corporates, and Family Offices.<br></br>
                              A passionate investor and lifelong learner, Priyanshu has a deep-rooted interest in value and growth investing, macroeconomic research, and trend-based trading. His approach to capital allocation is built on rigorous research, data-backed decision-making, and a constant curiosity about the ever-evolving financial markets.          
                        </p>
                        <p className="owner-description">
                           Under his leadership, the firm has positioned itself not just as a distributor but as a research-driven investment partner, offering curated products and insights across asset classes and strategies.

                        </p>
                    </div>
                    <div className="owner-image">
                        <img src={tsimg1} alt="Owner" />
                    </div>
                </div>
            </section>

            {/* team members */}
            <TeamSection />
            <br></br><br></br><br></br><br></br>
            <Footer />
        </div>
    )
}

export default About